exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.link-login {\n  margin-top: 1rem;\n  float: right; }\n  @media (min-width: 992px) {\n    .link-login {\n      color: #1664C6; } }\n\n.link-login:hover {\n  text-decoration: underline; }\n\n.btn-loginNewColor {\n  color: white;\n  background-color: #1664C6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/style/components/login/login-form.scss
// module id = 1084
// module chunks = 49